import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgWaveform = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 20, viewBox: "0 0 24 20", fill: props.fill, xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.2 1.6875C13.2 1.03066 12.6638 0.5 12 0.5C11.3363 0.5 10.8 1.03066 10.8 1.6875V18.3125C10.8 18.9693 11.3363 19.5 12 19.5C12.6638 19.5 13.2 18.9693 13.2 18.3125V1.6875ZM20.4 4.0625C20.4 3.40566 19.8638 2.875 19.2 2.875C18.5363 2.875 18 3.40566 18 4.0625V15.9375C18 16.5943 18.5363 17.125 19.2 17.125C19.8638 17.125 20.4 16.5943 20.4 15.9375V4.0625ZM9.6 5.25C9.6 4.59316 9.06375 4.0625 8.4 4.0625C7.73625 4.0625 7.2 4.59316 7.2 5.25V14.75C7.2 15.4068 7.73625 15.9375 8.4 15.9375C9.06375 15.9375 9.6 15.4068 9.6 14.75V5.25ZM16.8 6.4375C16.8 5.78066 16.2638 5.25 15.6 5.25C14.9363 5.25 14.4 5.78066 14.4 6.4375V13.5625C14.4 14.2193 14.9363 14.75 15.6 14.75C16.2638 14.75 16.8 14.2193 16.8 13.5625V6.4375ZM6 8.8125C6 8.15566 5.46375 7.625 4.8 7.625C4.13625 7.625 3.6 8.15566 3.6 8.8125V11.1875C3.6 11.8443 4.13625 12.375 4.8 12.375C5.46375 12.375 6 11.8443 6 11.1875V8.8125ZM0 10C0 10.6568 0.53625 11.1875 1.2 11.1875C1.86375 11.1875 2.4 10.6568 2.4 10C2.4 9.34316 1.86375 8.8125 1.2 8.8125C0.53625 8.8125 0 9.34316 0 10ZM21.6 10C21.6 10.6568 22.1363 11.1875 22.8 11.1875C23.4638 11.1875 24 10.6568 24 10C24 9.34316 23.4638 8.8125 22.8 8.8125C22.1363 8.8125 21.6 9.34316 21.6 10Z" }));
});
export default SvgWaveform;
